<template>
  <div class="ui-pivot-table-panel-sort">
    <UISort
      v-if="isColumnsVisible"
      v-model="sortCols"
      v-model:storage="sortColsStorage"
      :disabled
      :placement
      size="xxs"
      disallow-drag
      button-label="Col"
      :fields="columnsFields"
    />
    <UISort
      v-if="isRowsVisible"
      v-model="sortRows"
      v-model:storage="sortRowsStorage"
      :disabled
      :placement
      size="xxs"
      disallow-drag
      button-label="Row"
      :fields="rowsFields"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { DropdownListData, Sort } from '@types'
import { PivotTableConfig } from '../utils/types'

import { prepareSortFields } from '../utils/helpers'

import { UISort } from '@ui/controllers'

type Props = {
  columnsFields?: DropdownListData[]
  rowsFields?: DropdownListData[]
}

const props = defineProps<Props>()

const modelValue = defineModel<PivotTableConfig>()

const sortCols = defineModel<Sort[]>('sortCols')
const sortRows = defineModel<Sort[]>('sortRows')

const disableCols = inject<boolean>('disableCols')

const placement = 'bottom-end'

const sortColsStorage = computed({
  get() {
    return prepareSortFields(modelValue.value?.sortColumns, props.columnsFields)
  },
  set(sortColumns) {
    if (!modelValue.value) return
    modelValue.value = {
      ...modelValue.value,
      sortColumns,
    }
  },
})

const sortRowsStorage = computed({
  get() {
    return prepareSortFields(modelValue.value?.sortRows, props.rowsFields)
  },
  set(sortRows) {
    if (!modelValue.value) return
    modelValue.value = {
      ...modelValue.value,
      sortRows,
    }
  },
})

const disabled = computed(() => !props.columnsFields || !props.rowsFields)

const isColumnsVisible = computed(
  () => !disableCols && props.columnsFields?.length,
)
const isRowsVisible = computed(() => props.rowsFields?.length)
</script>

<style>
.ui-pivot-table-panel-sort {
  @apply flex items-center gap-1;
}
</style>
